import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { IBaseResponse } from '@carm/_utils/models';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { IDDBErrorsResponse, IDeleteDraftRequest } from '../models/api';
import { LoaderSpinnerTypes } from '@carm/_core';
import { IDutyDrawbackResponse, IGetDDBTransactions, IGetDDBClaims, IDDBClaim, IGetDDBExports, IDDBExportResponse } from '../models';

@Injectable()
export class DutyDrawbackService extends BaseApiService {
  constructor(protected injector: Injector) {
    super(injector);
  }

  getSubmittedDDBbyUid(uid: string): Observable<IDutyDrawbackResponse> {
    const endPoint = `${this.endPointBP}/cad/dutydrawback/${uid}`;
    return this.httpGet<IDutyDrawbackResponse>(endPoint);
  }

  getDDBTransactionsbyUid(
    uid: string,
    currentPage: number,
    pageSize: number
  ): Observable<IGetDDBTransactions> {
    const endPoint = `${this.endPointBP}/cad/dutydrawback/${uid}/transactions`;
    const params = new HttpParams()
      .set('pageSize', pageSize.toString())
      .set('currentPage', currentPage.toString());
    return this.httpAuthGet<IGetDDBTransactions>(endPoint, params);
  }

  getDDBGoodsbyTransaction(
    transactionUid: string,
    currentPage: number,
    pageSize: number,
    sort: string
  ): Observable<IGetDDBClaims> {
    const endPoint = `${this.endPointBP}/cad/dutydrawback/transactions/${transactionUid}/goods`;
    const params = new HttpParams()
      .set('pageSize', pageSize.toString())
      .set('currentPage', currentPage.toString())
      .set('sort', sort);
    return this.httpAuthGet<IGetDDBClaims>(endPoint, params, LoaderSpinnerTypes.AgGrid);
  }

  getDDBClaimDetails(goodUid: string): Observable<IDDBClaim> {
    const endPoint = `${this.endPointBP}/cad/dutydrawback/goods/${goodUid}`;
    return this.httpAuthGet<IDDBClaim>(endPoint);
  }

  getDDBExportsbyGoodUid(
    goodUid: string,
    currentPage: number,
    pageSize: number,
    sort: string
  ): Observable<IGetDDBExports> {
    const endPoint = `${this.endPointBP}/cad/dutydrawback/goods/${goodUid}/exports`;
    const params = new HttpParams()
      .set('pageSize', pageSize.toString())
      .set('currentPage', currentPage.toString());
    // .set('sort', sort);
    return this.httpAuthGet<IGetDDBExports>(endPoint, params, LoaderSpinnerTypes.AgGrid);
  }

  getDDBExportDetails(exportUid: string): Observable<IDDBExportResponse> {
    const endPoint = `${this.endPointBP}/cad/dutydrawback/goods/exports/${exportUid}`;
    return this.httpAuthGet<IDDBExportResponse>(endPoint);
  }

  validateTransactions(
    bn15: string,
    transactionNumbers: string[]
  ): Observable<boolean> {
    const endPoint = `${this.endPointBP}/precarm/validate`;
    const params = new HttpParams()
      .set('bn15', bn15)
      .set('transactionNumbers', `[${transactionNumbers.join(',')}]`);
    return this.httpGet<IBaseResponse>(endPoint, params).pipe(
      map(response => response.responseStatus === 'succeed')
    );
  }

  getTemplateToDownload(code: string): Observable<unknown> {
    const params = new HttpParams().set('code', code);
    const endPoint = `${this.endPointBP}/precarm/template/`;
    return this.httpAuthDownloadFile(endPoint, params);
  }

  withdrawDrawback(ddbUid: string, etag: string): Observable<IBaseResponse> {
    const deleteRequest: IDeleteDraftRequest = {
      etag,
    };
    const endPoint = `${this.endPointBP}/cad/dutydrawback/${ddbUid}`;
    return this.httpAuthDelete<IBaseResponse>(endPoint, null, deleteRequest);
  }

  downloadDrawback(drawbackUid: string): Observable<Blob> {
    const endPoint = `${this.endPointBP}/cad/dutydrawback/${drawbackUid}/pdf`;
    return this.httpAuthDownloadFile(endPoint);
  }

  getErrors(ddbUid: string): Observable<IDDBErrorsResponse> {
    const endPoint = `${this.endPointBP}/cad/dutydrawback/${ddbUid}/errors`;
    return this.httpAuthGet<IDDBErrorsResponse>(endPoint, null, LoaderSpinnerTypes.AgGrid);
  }
}
